interface APIProperty {
  name: string
  type: string
  defaultValue: string
  description: string
}

export function APITable({ properties }: { properties: APIProperty[] }) {
  return (
    <table className="w-full border-collapse">
      <thead>
        <tr className="border-cf-grey-100 border-b">
          <th className="text-cf-grey-900 px-4 py-2 text-left">Property</th>
          <th className="text-cf-grey-900 px-4 py-2 text-left">Type</th>
          <th className="text-cf-grey-900 px-4 py-2 text-left">Default</th>
          <th className="text-cf-grey-900 px-4 py-2 text-left">Description</th>
        </tr>
      </thead>
      <tbody>
        {properties.map(prop => (
          <tr key={prop.name} className="border-cf-grey-100 border-b">
            <td className="text-cf-grey-800 px-4 py-2">{prop.name}</td>
            <td className="text-cf-grey-700 px-4 py-2">
              <code className="bg-cf-grey-50 rounded px-1 py-0.5">{prop.type}</code>
            </td>
            <td className="text-cf-grey-700 px-4 py-2">
              <code className="bg-cf-grey-50 rounded px-1 py-0.5">{prop.defaultValue}</code>
            </td>
            <td className="text-cf-grey-700 px-4 py-2">{prop.description}</td>
          </tr>
        ))}
      </tbody>
    </table>
  )
}
